import Token from './token'
import Form from './form'

export default {
  svg: 'message_square',
  label: 'Send Internal SMS',
  type: 'administrative',
  action: 'sms',
  form: Form,
  token: Token
}
